<script>
import appConfig from "@/app.config";
import TvSocial from "@/components/TvSocial.vue";
import PandaWhiteCard from "@/components/PandaWhiteCard.vue";
import FooterLanguage from "@/components/FooterLanguage.vue";
import FooterNav from "@/components/FooterNav.vue";
import Social from "@/components/social.vue";
import SearchedCards from "@/components/SearchedCards.vue";
import { gsap } from "gsap";
import { isConsole } from "mobile-device-detect";
import { getCode, login } from '@/utils/login'
const tl3 = gsap.timeline();

export default {
  components: {
    TvSocial,
    // PandaWhiteCard,
    FooterLanguage,
    FooterNav,
    Social,
    SearchedCards,
  },
  props: {
    headerStyle: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      errorText: '',
      phone: localStorage.getItem('phone') || '',
      code: '',
      time: 0,
      isblur: true,
      checkPrivacy: false,
      isEn: false,
      assetsPath: appConfig.assetsPath,
      openMenu: false,
      searchText: "",
      openSearchMenu: false,
      scrollPosition: null,
      persistentNavRoutes: [],
      pandaWhiteCard: [],
      showSearchResults: false,
      language: "",
      searchValueData: [],
      searchResults: [
        {
          logo: "Icon_BigCorner_7@2x.png",
          title: "Dr. Panda Trucks",
          page: "Games",
          url: "/games",
        },
        {
          logo: "Icon_BigCorner_5@2x.png",
          title: "Dr. Panda Ice Cream Truck 2",
          page: "Games",
          url: "/games",
        },
        {
          logo: "Icon_BigCorner_1@2x.png",
          title: "Trucks Illustrations",
          page: "Games",
          url: "/games",
        },
      ],
    };
  },
  computed: {},
  created() {
    this.language = this.$i18n.locale;
  },
  mounted() {
    this.defaultload();
    window.addEventListener("scroll", this.updateScroll);
  },
  methods: {
    handleLinkTo(type) {
      const pageUrl = {
        terms: 'https://www.xiongmaoboshi.com/terms',
        privacy: 'https://www.xiongmaoboshi.com/privacy',
      };

      window.location.href = pageUrl[type];
    },
    getNum() {
      // console.log(data); //输出轮播到第几张图片
    },
    logon() {
      if (!this.checkPrivacy) {
        this.errorText = '请勾选同意服务条款和隐私政策'
        document
          .getElementsByClassName('privacy-check')[0]
          .setAttribute('style', 'border:' + '2px solid red');
        return false;
      }
      if (this.phone.length != 11) {
        this.errorText = '手机号码不足11位数'
        return false;
      }
      if (this.code.length < 4) {
        this.errorText = '请输入验证码'
        return false;
      }

      if (this.phone) {
         login(this.phone, this.code).then(res => {
          if(res.code === 0) {
            this.errorText = '恭喜您，登录成功'
            localStorage.setItem('phone', this.phone)
            this.$bvModal.hide("modal-login");
          }else {
            this.errorText = '登录失败，请重试'
          }
        })
      }
    },
    getSmsCode() {
      if (this.time <= 0 && this.phone) {
        if (this.phone.length !== 11) {
          this.errorText = '手机号码不足11位数'
          return false;
        }
        this.time = 60;
        this.createTime();
        getCode(this.phone).then(res => {
            this.errorText = '验证码发送成功'
        })
      }
    },
    createTime() {
      if (this.time <= 0) {
        return false;
      }
      this.time--;
      setTimeout(() => {
        this.createTime();
      }, 1000);
    },
    focus() {
      this.isblur = false;
      clearTimeout(this.blurTime);
    },
    blur() {
      this.blurTime = setTimeout(() => {
        this.isblur = true;
      }, 50);
    },
    handleLogin() {
      this.$bvModal.show("modal-login");
    },
    closeModal2() {
      this.$bvModal.hide("modal-login");
    },
    closeModal() {
      this.$bvModal.hide("modal-download");
    },
    menuClick(name) {
      if(name==='download') {
        this.$bvModal.show("modal-download");
      }
    },
    toggleMenu() {
      if (this.openSearchMenu) {
        this.openSearchMenu = false;
      } else {
        this.openMenu = !this.openMenu;
      }
      this.defaultload();
    },
    toggleSearchMenu() {
      this.openSearchMenu = true;
      this.gsapSearch();
      this.defaultload();
      this.showSearchResults = false;
    },
    closeMenu() {
      this.openMenu = false;
      this.openSearchMenu = false;
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    defaultload() {
      this.persistentNavRoutes = this.$t("header.persistentNavRoutes");
      this.pandaWhiteCard = this.$t("pandaWhiteCard");
    },
    gsapSearch() {
      tl3
        .to(".headerNav", { y: -80, duration: 0.1 }, "-=2")
        .from("#searchBlock", { y: -100, duration: 0.2 }, "-=1")
        .to("#nosearchCharacter", { y: -100, opacity: 1, duration: 0.2 }, "-=1")
        .to("#body-element", { overflow: "hidden", duration: 0.2 }, "-=2");
      tl3.play();
    },
    closeSearch() {
      // tl3.to('.headerNav', {y: -80, duration: 0.1}, "-=2")
      tl3.reversed(!tl3.reversed()).timeScale(-3.5);
      this.searchValueData = [];
      this.openSearchMenu = false;
      this.showSearchResults = false;
    },
    /** 防抖 */
    inputChange(str) {
      if (this.timer !== "") {
        clearTimeout(this.timer);
        this.timer = "";
      }
      this.timer = setTimeout(() => {
        this.searchText = str;
        this.searchValue(str);
        this.timer = "";
      }, 500);
    },
    /** 模糊搜索 */
    searchValue(str) {
      // console.log(str, "这是input内容");
      // console.log(this.language, "language");
      if (str) {
        this.searchValueData = []; // 搜索内容容器
        this.showSearchResults = true;
        const arr = window.gamesData.data[this.language].featureGame;
        Object.values(arr).forEach((v) => {
          if (
            v.title &&
            v.title.toLowerCase().indexOf(str.toLowerCase()) !== -1
          ) {
            this.searchValueData.push(v);
          }
        });
        window.gamesData.data[this.language].list.forEach((el) => {
          if (
            el.title &&
            el.title.toLowerCase().indexOf(str.toLowerCase()) !== -1
          ) {
            this.searchValueData.push(el);
          }
        });
        this.$nextTick(() => {
          if (this.searchValueData.length === 0) {
            this.$refs.searchTip.innerText = this.$t("header.searchNoResults");
          } else {
            this.$refs.searchTip.innerText = `${
              this.searchValueData.length
            } ${this.$t("header.searchResult")} '${this.searchText}'`;
          }
        });
      } else {
        this.searchValueData = [];
        this.showSearchResults = false;
      }
    },
    /** 点击搜索内容跳转 */
    turnToDetail(v) {
      if (
        v.route === "ca" ||
        v.route === "cc" ||
        v.route === "learn&play" ||
        v.route === "town"
      ) {
        this.GLOBAL.routetrGo(`${v.route}`);
      } else {
        this.GLOBAL.routetrGo(`games/${v.route}`);
      }
    },
  },
  updated() {
    this.defaultload();
    this.language = localStorage.getItem("dpLang");
  },
};
</script>

<template>
  <div
    :class="[
      { navActive: openMenu, '': !openMenu },
      { navActive: openSearchMenu, '': !openSearchMenu },
    ]"
  >
    <header
      :class="[{ changeColor: scrollPosition > 50 }, headerStyle]"
      class="headerNav"
    >
      <div v-if="!phone" class="login" @click="handleLogin">登录/注册</div>
      <div v-if="phone" class="login">{{ phone }}</div>
      <b-modal
        id="modal-download"
        scrollable
        title="Scrollable Content"
        modal-class="fullscreen-modal"
        hide-footer
        hide-header
        header-class="careers-modal-header"
      >
        <img
          :class="$style.closeIcon"
          :src="assetsPath + 'images/icons/CloseIcon.svg'"
          @click="closeModal"
        />

        <div class="mb-5" :class="$style.blockModal">
          <img :class="$style.downloadCode" src="https://yuwen.xiongmaoboshi.com/test/img/download_code-1691055118530-831.png" />
          <p>扫码下载应用</p>
        </div>
      </b-modal>
       <b-modal
        id="modal-login"
        scrollable
        title="Scrollable Content"
        modal-class="fullscreen-modal"
        hide-footer
        hide-header
        header-class="careers-modal-header"
      >
        <img
          :class="$style.closeIcon"
          :src="assetsPath + 'images/icons/CloseIcon.svg'"
          @click="closeModal2"
        />

        <div class="mb-5" :class="$style.blockModalLogin">
          <div class="yqlc" @click.stop>
            <div
              class="title-img"
            >
              用户登录
            </div>
            <div class="input-container">
              <div class="input">
                <input
                  @focus="focus"
                  @blur="blur"
                  v-model="phone"
                  type="tel"
                  onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  placeholder="请输入手机号"
                  maxlength="11"
                />
              </div>
              <button class="loginBtn " style="visibility: hidden;" :class="time === 0 && 'getSmsCode'">
                {{ time ? `${time}秒` : '获取验证码' }}
              </button>
            </div>
            <div class="input-container">
              <div class="input">
                <input
                  @focus="focus"
                  @blur="blur"
                  v-model="code"
                  placeholder="请输入验证码"
                  onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  type="tel"
                  maxlength="6"
                />
              </div>
              <button class="btn" :class="time === 0 && 'getSmsCode'" @click="getSmsCode">
                {{ time ? `${time}秒` : '获取验证码' }}
              </button>
            </div>
            <p class="errorText">{{ errorText }}</p>
            <button
              class="button"
              @click="logon"
              :class="{
                button_disabled: phone.length == 11 && code.length >= 4 ? false : true,
              }"
            >
              立即登录
            </button>
            <div class="login-tips">
              <input class="privacy-check" type="checkbox" id="checkbox" v-model="checkPrivacy" />
              <p class="import-box">
                已同意我们的<span class="import" @click="handleLinkTo('privacy')">《隐私政策》</span>和
                <span class="import" @click="handleLinkTo('terms')">《服务条款》</span>
              </p>
            </div>
    </div>
        </div>
      </b-modal>
      <b-container no-gutter>
        <b-navbar toggleable="lg" class="pt-0 px-0">
          <b-navbar-brand href="/">
            <div :class="language == 'en' ? $style.hidelogoword : ''">
              <img
                :src="assetsPath + 'images/drPanda-logo.png'"
                :class="$style.logo"
              />
              <div class="companyName"><p>重庆创浪时代</p><p>未来科技有限公司</p></div>
            </div>
          </b-navbar-brand>
          
          <b-navbar-toggle class="border-0 outline-0" target="">
            <template>
              <div class="d-flex flex-row align-content-center">
                <div class="search-icon" @click="toggleSearchMenu">
                  <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="Web"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="Web-Home"
                        transform="translate(-1284.000000, -38.000000)"
                      >
                        <g id="Nav">
                          <path
                            d="M1286.85716,48.2857143 C1286.85716,44.1897143 1290.18975,40.8571429 1294.28578,40.8571429 C1298.3818,40.8571429 1301.71439,44.1897143 1301.71439,48.2857143 C1301.71439,52.3817143 1298.3818,55.7142857 1294.28578,55.7142857 C1290.18975,55.7142857 1286.85716,52.3817143 1286.85716,48.2857143 Z M1307.163,57.1222857 L1303.29211,53.2514286 C1304.10526,51.7788571 1304.57155,50.0868571 1304.57155,48.2857143 C1304.57155,42.6051429 1299.96638,38 1294.28578,38 C1288.60517,38 1284,42.6051429 1284,48.2857143 C1284,53.9662857 1288.60517,58.5714286 1294.28578,58.5714286 C1296.08693,58.5714286 1297.77894,58.1057143 1299.25095,57.292 L1303.1224,61.1634286 C1304.23841,62.2788571 1306.04756,62.2788571 1307.163,61.1634286 C1308.279,60.0474286 1308.279,58.2382857 1307.163,57.1222857 L1307.163,57.1222857 Z"
                            id="Search"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>

                <div class="toggle-btn-box">
                  <svg
                    class="ham hamRotate ham1"
                    viewBox="0 0 100 100"
                    width="80"
                    :class="[{ active: openMenu, 'not-active': !openMenu }]"
                    @click="toggleMenu"
                  >
                    <path
                      class="line top"
                      d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
                    />
                    <path class="line middle" d="m 30,50 h 40" />
                    <path
                      class="line bottom"
                      d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"
                    />
                  </svg>
                </div>
              </div>
            </template>
          </b-navbar-toggle>

          <b-collapse is-nav>
            <b-navbar-nav class="w-100 nav-links">
              <li class="w-100">
                <b-navbar-nav class="m-auto" :class="$style.menuWidth">
                  <b-nav-item
                    @click="menuClick(link.name)"
                    :href="
                      link.name.indexOf('//') > -1
                        ? link.name
                        : (link.name !=='download' ? GLOBAL.hrefLink(link.name) :'')
                    "
                    v-for="(link, index) in persistentNavRoutes"
                    :key="index"
                    >{{ link.title }}</b-nav-item
                  >
                </b-navbar-nav>
              </li>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <!-- <select v-model="$i18n.locale">
<option value="en">English</option>
<option value="zh">chinese</option>
</select> -->
              <div class="search-icon" @click="toggleSearchMenu">
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <g
                    id="Web"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      id="Web-Home"
                      transform="translate(-1284.000000, -38.000000)"
                    >
                      <g id="Nav">
                        <path
                          d="M1286.85716,48.2857143 C1286.85716,44.1897143 1290.18975,40.8571429 1294.28578,40.8571429 C1298.3818,40.8571429 1301.71439,44.1897143 1301.71439,48.2857143 C1301.71439,52.3817143 1298.3818,55.7142857 1294.28578,55.7142857 C1290.18975,55.7142857 1286.85716,52.3817143 1286.85716,48.2857143 Z M1307.163,57.1222857 L1303.29211,53.2514286 C1304.10526,51.7788571 1304.57155,50.0868571 1304.57155,48.2857143 C1304.57155,42.6051429 1299.96638,38 1294.28578,38 C1288.60517,38 1284,42.6051429 1284,48.2857143 C1284,53.9662857 1288.60517,58.5714286 1294.28578,58.5714286 C1296.08693,58.5714286 1297.77894,58.1057143 1299.25095,57.292 L1303.1224,61.1634286 C1304.23841,62.2788571 1306.04756,62.2788571 1307.163,61.1634286 C1308.279,60.0474286 1308.279,58.2382857 1307.163,57.1222857 L1307.163,57.1222857 Z"
                          id="Search"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>

              <div class="toggle-btn-box">
                <svg
                  class="ham hamRotate ham1"
                  viewBox="0 0 100 100"
                  width="80"
                  :class="[{ active: openMenu, 'not-active': !openMenu }]"
                  @click="toggleMenu"
                >
                  <path
                    class="line top"
                    d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
                  />
                  <path class="line middle" d="m 30,50 h 40" />
                  <path
                    class="line bottom"
                    d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"
                  />
                </svg>
              </div>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </b-container>
    </header>
    <div
      class="mobile-nav main-menu-nav"
      :class="[$style.navContent, { active: openMenu, '': !openMenu }]"
    >
      <div class="mobile-nav__content" :class="$style.mobileNav__content">
        <div :class="$style.scrollBlock">
          <b-container class="header-menu-container">
            <ul class="mobile-nav__list" :class="$style.mobileNavList">
              <li class="mobile-nav__list-item">
                <b-row class="flex-lg-row-reverse">
                  <b-col
                    col
                    lg="8"
                    md="12"
                    sm="12"
                    cols="12"
                    class="animate-block"
                  >
                    <b-row class="flex-lg-row-reverse">
                      <b-col
                        col
                        lg="6"
                        md="6"
                        sm="12"
                        cols="12"
                        class="amimate-1"
                      >
                        <div :class="$style.footerMenu">
                          <FooterLanguage
                            class="w-100 mb-5"
                            :defaultload="defaultload"
                          />
                          <FooterNav class="w-100 text-left" />
                          <div
                            :class="$style.mobileSocialTv"
                            class="d-md-none text-left"
                          >
                            <TvSocial customClass="d-none" />
                          </div>
                        </div>
                      </b-col>
                      <!-- <b-col
                        col
                        lg="6"
                        md="6"
                        sm="12"
                        cols="12"
                        class="amimate-2"
                      >
                        <PandaWhiteCard
                          class="mb-4"
                          v-for="(data, index) in pandaWhiteCard"
                          :data="data"
                          :key="index"
                        />
                      </b-col> -->
                    </b-row>
                  </b-col>
                  <b-col
                    col
                    lg="4"
                    md="12"
                    sm="12"
                    cols="12"
                    class="animate-block px-0"
                  >
                    <div class="d-md-none">
                      <Social />
                    </div>
                    <div
                      :class="$style.socialTv"
                      class="d-none d-md-inline-block"
                    >
                      <TvSocial customClass="" />
                    </div>
                  </b-col>
                </b-row>
              </li>
            </ul>
          </b-container>
        </div>
      </div>
    </div>
    <div
      class="mobile-nav main-search-block"
      :class="[
        $style.navContent,
        { active: openSearchMenu, '': !openSearchMenu },
      ]"
    >
      <div :class="$style.searchFixed">
        <div
          :class="[$style.searchBlock, openSearchMenu ? $style.active : '']"
          id="searchBlock"
        >
          <div :class="[$style.searchField]">
            <!-- v-on:keyup="keymonitor" -->
            <b-container class="p-rel">
              <!-- search输入框 -->
              <b-form-input
                type="text"
                :placeholder="
                  this.language === 'en'
                    ? 'Type to search..'
                    : '请输入搜索内容..'
                "
                @input="inputChange"
              ></b-form-input>
              <div :class="$style.closeSearchIcon">
                <svg
                  class="ham hamRotate ham1 black active"
                  viewBox="0 0 100 100"
                  width="80"
                  @click="closeSearch"
                >
                  <path
                    class="line top"
                    d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
                  />
                  <path class="line middle" d="m 30,50 h 40" />
                  <path
                    class="line bottom"
                    d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"
                  />
                </svg>
              </div>
            </b-container>
          </div>
        </div>
        <div class="w-100 d-inline-block">
          <b-container>
            <div :class="$style.searchCenterBlock" v-if="showSearchResults">
              <h3 class="text-center" ref="searchTip">
                {{ this.searchValueData.length }}
                {{ this.$t("header.searchResult") }} '{{ searchText }}'
              </h3>
              <div
                :class="$style.searchedCards"
                v-for="(data, index) in searchValueData"
                :key="index"
                class="w-100 d-inline-block"
                @click="turnToDetail(data)"
              >
                <SearchedCards :data="data" />
              </div>
            </div>
          </b-container>
        </div>
        <img
          :src="assetsPath + 'images/Olette-static@2x.png'"
          :class="$style.nosearchCharacter"
          id="nosearchCharacter"
          v-if="!showSearchResults"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/design/index.scss";
</style>
<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.blockModal{
  width: 100vw;
  height: 100vh;
  display: flex !important;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 44px;
  font-weight: bold;
}

.downloadCode{
  width: 10vw;
}

.closeIcon {
  position: absolute;
  top: 20px;
  right: 30px;
  z-index: 11;
  cursor: pointer;
}

.searchFixed {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  .nosearchCharacter {
    position: fixed;
    bottom: -150px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 233px;
    opacity: 0;
  }
}
.searchCenterBlock {
  margin-top: 160px;
  width: 500px;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 100px;
  h3 {
    font-size: 18px;
    color: #231f20;
    margin-bottom: 30px;
  }
}
.searchedCards {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.searchBlock {
  float: left;
  width: 100vw;
  position: fixed;
  top: 0;
  z-index: 1;
  opacity: 0;
  &.active {
    opacity: 1;
  }
  .searchField {
    float: left;
    width: 100%;
    background-color: #fff;
    border-bottom: 2px solid #d3d2d2;
    input {
      height: 100px;
      border: none;
      box-shadow: none;
      font-size: 22px;
    }
  }
  .closeSearchIcon {
    position: absolute;
    right: 0;
    top: 10px;
    transform: scale(0.8);
  }
}
.hidelogoword {
  width: 99px;
  height: 52px;
  overflow: hidden;
}
.logo {
  width: 99px;
}

.menuWidth {
  width: 550px;
}
.cardBlock {
  width: 360px;
}
.navLink {
  width: 360px;
  max-width: 33.33%;
}
.socialTv {
  padding-top: 100px;
  width: 300px;
  float: left;
}
.footerMenu {
}
.mobileNavList {
  padding: 0;
  max-width: 100%;
}
.mobileSocialTv {
  padding-top: 40px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 40px;
}

@media only screen and (max-width: 991px) {
  .mobileNavList {
    padding: 0 0;
    padding-top: 100px;
    display: flex;
    flex-direction: column-reverse;
  }
  .mobileNav__content {
    width: 100vw;
    left: 0;
    top: 0;
    transform: none;
  }
  .scrollBlock {
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      opacity: 0;
    }
  }

  .socialTv,
  .cardBlock,
  .navLink {
  }
  .navContent {
  }
}

@media only screen and (max-width: 767px) {
  .searchBlock {
    .searchField {
      input {
        height: 70px;
      }
      .closeSearchIcon {
        top: -3px;
        transform: scale(0.5);
      }
    }
  }
}
</style>
